import { defineAbility } from '@casl/ability';

import { AbilityActions, AbilitySubjects } from './constants';

export const ability = defineAbility((can) => {
    can(AbilityActions.use, AbilitySubjects.app);
});
